export default "__VITE_ASSET__DSfE3pcK__"